interface JWTTokenPayload {
  OrganizationUserId: string;
  RoleIds: string;
  jti: string;
  nbf: number;
  exp: number;
  iat: number;
}

export const decodeJWTToken = (token: string): JWTTokenPayload | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    const payload = parts[1];

    const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4);

    const decodedPayload = atob(paddedPayload);

    const parsedPayload = JSON.parse(decodedPayload) as JWTTokenPayload;

    return parsedPayload;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

export const getOrganizationUserIdFromToken = (token: string): string | null => {
  const payload = decodeJWTToken(token);
  return payload?.OrganizationUserId || null;
};
